import {
  Buildings, FirstAid, Briefcase, Stairs, SprayBottle,
  SunHorizon, Wrench, Factory, Storefront, House,
} from "@phosphor-icons/react";

// slug used for /leistungen/:slug detail pages
export const SERVICES = [
  {
    slug: "bueroreinigung",
    icon: Briefcase,
    title: "Büroreinigung",
    short: "Ein sauberes Büro für konzentriertes, professionelles Arbeiten.",
    long: "Ein gepflegtes Arbeitsumfeld steigert Produktivität und hinterlässt bei Kunden einen bleibenden Eindruck. Wir reinigen Arbeitsplätze, Konferenzräume, Küchen und Sanitärbereiche – zuverlässig, diskret und flexibel nach Ihren Zeiten.",
    image: "https://images.pexels.com/photos/8135119/pexels-photo-8135119.jpeg",
    points: ["Tägliche oder wöchentliche Unterhaltsreinigung", "Sanitär- und Küchenhygiene", "Fußböden, Oberflächen & Glasflächen", "Flexible Zeiten außerhalb Ihrer Geschäftszeiten"],
  },
  {
    slug: "praxisreinigung",
    icon: FirstAid,
    title: "Praxisreinigung",
    short: "Hygiene auf höchstem Niveau für Arzt- und Zahnarztpraxen.",
    long: "In medizinischen Einrichtungen zählt jedes Detail. Unser geschultes Personal arbeitet nach strengen Hygienevorgaben und sorgt für ein sicheres, makelloses Umfeld für Patienten und Personal.",
    image: "https://images.unsplash.com/photo-1781637590564-01c65dbf2039",
    points: ["Desinfektion nach Hygienestandards", "Behandlungs- & Wartebereiche", "Diskretion und Zuverlässigkeit", "Dokumentierte Qualitätskontrolle"],
  },
  {
    slug: "gewerbereinigung",
    icon: Storefront,
    title: "Gewerbereinigung",
    short: "Repräsentative Sauberkeit für Hotels, Restaurants & Handel.",
    long: "Ihr Geschäft ist Ihre Visitenkarte. Wir sorgen dafür, dass Ihre Räume jederzeit einladend und makellos sind – von der Lobby bis zum Gastraum.",
    image: "https://images.pexels.com/photos/11861957/pexels-photo-11861957.jpeg",
    points: ["Hotels, Restaurants & Einzelhandel", "Repräsentative Empfangsbereiche", "Flexible Intervalle", "Auf Wunsch auch abends & am Wochenende"],
  },
  {
    slug: "treppenhausreinigung",
    icon: Stairs,
    title: "Treppenhausreinigung",
    short: "Gepflegte Treppenhäuser für ein hochwertiges Gesamtbild.",
    long: "Das Treppenhaus ist der erste Eindruck jedes Gebäudes. Wir halten Eingänge, Treppen, Geländer und Gemeinschaftsflächen dauerhaft sauber und einladend.",
    image: "https://images.pexels.com/photos/37320179/pexels-photo-37320179.jpeg",
    points: ["Regelmäßige Unterhaltsreinigung", "Eingänge, Treppen & Geländer", "Gemeinschaftsflächen", "Zuverlässige feste Intervalle"],
  },
  {
    slug: "glasreinigung",
    icon: SprayBottle,
    title: "Glasreinigung",
    short: "Streifenfreie Fenster und glänzende Glasfassaden.",
    long: "Klare Sicht, brillanter Glanz. Wir reinigen Fenster, Glasfronten und Fassaden – auch in der Höhe – mit modernster Technik für ein makelloses Ergebnis.",
    image: "https://images.pexels.com/photos/11861957/pexels-photo-11861957.jpeg",
    points: ["Fenster innen & außen", "Glasfassaden & Schaufenster", "Reinigung in der Höhe", "Streifenfreies Premium-Ergebnis"],
  },
  {
    slug: "solarreinigung",
    icon: SunHorizon,
    title: "Solarreinigung",
    short: "Mehr Ertrag durch professionell gereinigte Solaranlagen.",
    long: "Verschmutzte Module verlieren an Leistung. Mit schonender, entkalkter Reinigung steigern wir den Wirkungsgrad Ihrer Photovoltaik-Anlage und schützen langfristig Ihre Investition.",
    image: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d",
    points: ["Schonende Reinigung mit reinem Wasser", "Höherer Energieertrag", "Werterhalt der Anlage", "Für Gewerbe & Industrie"],
  },
  {
    slug: "hausmeisterservice",
    icon: Wrench,
    title: "Hausmeisterservice",
    short: "Rundum-Betreuung für Ihre Immobilie das ganze Jahr.",
    long: "Von kleinen Reparaturen über Grünflächenpflege bis zum Winterdienst – wir kümmern uns zuverlässig um Ihre Immobilie, damit Sie sich um nichts sorgen müssen.",
    image: "https://images.pexels.com/photos/37320179/pexels-photo-37320179.jpeg",
    points: ["Objektbetreuung & kleine Reparaturen", "Grünflächen- & Außenpflege", "Winterdienst", "Regelmäßige Kontrollgänge"],
  },
  {
    slug: "industriereinigung",
    icon: Factory,
    title: "Industriereinigung",
    short: "Leistungsstarke Reinigung für Hallen und Produktion.",
    long: "Industrielle Umgebungen stellen besondere Anforderungen. Wir reinigen Produktionshallen, Lager und Maschinenumfelder effizient und nach höchsten Sicherheitsstandards.",
    image: "https://images.pexels.com/photos/8135119/pexels-photo-8135119.jpeg",
    points: ["Produktions- & Lagerhallen", "Maschinen- & Anlagenumfeld", "Bodenreinigung großer Flächen", "Nach Sicherheitsstandards"],
  },
  {
    slug: "privatkunden",
    icon: House,
    title: "Privatkunden & Individuelle Anfragen",
    short: "Professionelle Reinigung für Privathaushalte – diskret und ohne Vorurteile.",
    long: "Ob regelmäßige Haushaltsreinigung, eine einmalige Grundreinigung oder Unterstützung in einer besonders anspruchsvollen Situation – wir finden gemeinsam eine passende Lösung für Sie. Auch herausfordernde und stark verschmutzte Objekte übernehmen wir mit Professionalität, Respekt und ohne zu urteilen. Jede Anfrage wird individuell und diskret behandelt. Ihre Privatsphäre und Vertraulichkeit stehen für uns immer an erster Stelle.",
    image: "https://images.pexels.com/photos/8135119/pexels-photo-8135119.jpeg",
    points: ["Haushalte, Wohnungen & Häuser", "Einmalige Grund- & Tiefenreinigung", "Umzugs- & Entrümpelungsreinigung", "Diskret, respektvoll & vertraulich"],
  },
];

export { Buildings };
